import { render, staticRenderFns } from "./whisky-glass.vue?vue&type=template&id=2d0a10c0"
import script from "./whisky-glass.vue?vue&type=script&lang=js"
export * from "./whisky-glass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports